<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>AIC ONE - Login</title>
</head>

<body class="login-home background-body">
  <div class="container auth-logo-card-spacing align-items-center d-flex">
      <!-- Logo Section -->
      <div class="logo-section">
        <img :src="styleConfig.login_page_logo"
          alt="aicone Logo"
          class="logo"/>
        <div class="user-count d-none">
          <div class="user-dots d-flex">
            <div class="dot"></div>
            <div class="dot"></div>
            <div class="dot"></div>
          </div>
          <span>3k+ people joined us, now it's your turn</span>
        </div>
      </div>

      <!-- Login Form -->
      <div class="sign-in-form">
        <div class="mb-4 text-start">
          <h2 class="text-black fw-bold">Log in</h2>
            <p class="text-black mt-3 fw-bold" :class="{ 'd-none': !(is_cloud_domain && is_internal) }">New user? <a href="/register" class="text-black">Create an account</a></p>


        </div>

        <form @submit.prevent="submit_form">

         <div class="form-floating-custom">
              <input type="text" class="form-input" placeholder=" " v-model="form.email">
              <label for="" class="form-label">Email Address</label>
              <div v-if="errors.email" class="error-message text-start text-danger small">{{ errors.email }}</div>
          </div>

          <div class="form-floating-custom password-group">
              <input :type="password_visible ? 'text' : 'password'" id="password" class="form-input" placeholder="" v-model="form.password">
              <label for="password" class="form-label">Password</label>
               <button type="button" class="password-toggle" @click="password_visibility()">
                <i :class="password_visible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
            <div v-if="errors.password" class="error-message text-start text-danger fs-6">{{ errors.password }}</div>

          </div>

          <button
            type="submit"
            class="btn sign-up-btn btn-dark w-100 fw-bold mb-2"
            :disabled="loading"
          >
            <span v-if="!loading">Log In</span>

            <div v-else class="spinner-border spinner-border-sm text-light" role="status"></div>
          </button>
         <div class="dropdown">
      </div>
          <div class="forgot-password mt-3 text-center small">
            <span>
              Forgot your password?
              <a href="/reset">Click here</a> to reset
            </span>
          </div>
        </form>
      </div>
  </div>
  <!-- Powered By Footer -->
  <div class="position-fixed bottom-0 start-50 translate-middle-x small text-white pb-3">
    © {{ current_year }} Powered by <span class="fw-bold">{{ powered_by_name }}</span>
  </div>

</body>
